import {Component, OnInit, Inject, Input, InjectionToken} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef, MatDialog} from '@angular/material';
import {Router} from '@angular/router';
import {Paginate} from '../../search-document-sign/search-document-sign.component';
import {DataSource} from '@angular/cdk/collections';
import {BehaviorSubject, Observable} from 'rxjs';
import {DocumentService} from 'src/app/core/services/document.service';
import {debug} from 'util';
import {ApprovalDocumentComponent} from '../../approval-document/approval-document.component';
import {Location} from '@angular/common';
import {Message} from '../../../../../../../core/class/message';
import {CommonService} from '../../../../../../../core/services/common.service';
import { ContractService } from 'src/app/core/services/contract.service';
import { ToastrService } from 'ngx-toastr';
import { WarningDataAuthenticationComponent } from 'src/app/shared/components/warning-data-authentication/warning-data-authentication.component';
import { SignAuthenticationPopupComponent } from '../../add-document-moha/sign-aunthentication-popup/sign-aunthentication-popup.component';
import { RequestConfirmIdentityComponent } from 'src/app/shared/components/request-confirm-identity/request-confirm-identity.component';
import { EnterIdentityVneidComponent } from 'src/app/shared/components/enter-identity-vneid/enter-identity-vneid.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { DocumentMohaService } from 'src/app/core/services/document-moha.service';

/**
 * The document model.
 */
export class Document {
  name: string;
  id: string;
  code: string;
  createdTime: string;
  finishDate: string;
  createdUser: string;
  isSignDigitalCertificate: boolean;
  customerName: string;
  taxCode: string;
  customerTaxCode: string;
  customerCertificateNo: string;
  status: number;
  parentId: string;
  enterprise: string;
  documentType: any;
  type: any;
  email: string;
  checked: boolean;
}

/**
 * document source.
 */
export class DocumentDataSource extends DataSource<Document> {
  /** Stream of data that is provided to the table. */
  public data = new BehaviorSubject<Document[]>([]);

  /**
   * Create new instance.
   */
  constructor() {
    super();
  }


  setData(data: Document[]) {

    this.data.next(data);
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<Document[]> {
    return this.data.asObservable();
  }

  disconnect(): void {
    this.data.complete();
  }
}

@Component({
  selector: 'app-approve-document-list',
  templateUrl: './approve-document-list.component.html',
  styleUrls: ['./approve-document-list.component.scss']
})

/**
 * Sign document list component.
 */
export class ApproveDocumentListComponent implements OnInit {


  /**
   * stop sign action.
   */
  public static CONFIRM_ACTION = 'confirm';

  public static CONFIRM_ACTION_NON_CERTIFICATE = 'confirm2';
  public static DECLINE_ACTION = 'decline';

  /**
   * close popup action.
   */
  public static CLOSE_ACTION = 'close';

  /**
   * sign all document.
   */
  public static SIGN_ALL = 'all';

  /**
   * Sign a slot.
   */
  public static SIGN_SLOT = 'slot';

  public static TYPE_CONTRACT_NON_CERTIFICATE = 'non certificate';

  public static TYPE_CONTRACT_WITH_CERTIFICATE = 'with certificate';

  public static TYPE_CONTRACT_MIX_CERTIFICATE = 'mix certificate';

  /**
   * Stream of data that is provided to the table.
   */
  public actions = new BehaviorSubject<string>('');

  /**
   * sign option.
   */
  private signOption: string;

  /**
   * slot of documents.
   */
  private slotDocuments: any;

  /**
   * filter by sign all condition.
   */
  private filterSignAll: any;

  dataSource: any;

  tmp: any;
  dataCheckVneid: any;

  paginate: Paginate;

  documents = new Document();

  noOfFiles: 0;
  public userType: number = Number(localStorage.getItem('userType'));
  conTractWithCertificate: 0;
  typeContracts: string;
  conTractWithoutCertificate: 0;
  notifyWarning: string;

  displayedColumns: string[] = [
    'STT',
    'contractName',
    'noOfFile',
    'allName',
    'createdUser',
    'isSignDigitalCertificate',
    'receivedTime'
    // 'symbol',
  ];

  /**
   *
   * @param data
   *   + signOption sign option.
   *   + slotDocuments slot of documents.
   *   + filterSignAll filter option of sign all.
   * @param router The router.
   * @param documentService The document service.
   */
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      signOption: string,
      slotDocuments: any,
      filterSignAll: any,
    },
    private location: Location,
    private router: Router,
    private documentService: DocumentService,
    private dialog: MatDialog,
    private message: Message,
    private commonService: CommonService,
    private contractService: ContractService,
    private toastr: ToastrService,
    public deviceService: DeviceDetectorService,
    private documentMohaService: DocumentMohaService,
  ) {
    this.signOption = data.signOption;
    this.slotDocuments = data.slotDocuments;
    this.filterSignAll = data.filterSignAll;
  }

  /**
   * Initialize data.
   */
  ngOnInit() {
    if (this.signOption === ApproveDocumentListComponent.SIGN_ALL) {
      this.loadDocumentsByApproveAll();
    } else {
      console.log('slot: ' + JSON.stringify(this.slotDocuments));
      const dataSource = this.slotDocuments.value.map(item => ({
        ...item,
        contractName: item.name,
      }));
      console.log('dataSourcedataSource', dataSource);

      dataSource.sort((a, b) => {
        if (a.isSignDigitalCertificate === true && b.isSignDigitalCertificate === false) {
          return -1;
        } else if (a.isSignDigitalCertificate === false && b.isSignDigitalCertificate === true) {
          return 1; // b đứng trước a
        } else {
          return 0;
        }
      });
      this.noOfFiles = dataSource.filter(item => item.isSignDigitalCertificate === true).reduce(function(s, a) {
        return s + a.contractAttachments.length;
      }, 0);
      if (!dataSource.some(item => item.isSignDigitalCertificate === true)) {
        this.typeContracts = ApproveDocumentListComponent.CONFIRM_ACTION_NON_CERTIFICATE;
      } else if (!dataSource.some(item => item.isSignDigitalCertificate === false)) {
        this.typeContracts = ApproveDocumentListComponent.TYPE_CONTRACT_WITH_CERTIFICATE;
      } else {
        this.typeContracts = ApproveDocumentListComponent.TYPE_CONTRACT_MIX_CERTIFICATE;
      }
      const validData = dataSource.filter(x => x.status === 2 && x.cStatus !== 3 && x.cStatus !== 5);
      this.conTractWithCertificate = validData.filter((item) => item.isSignDigitalCertificate === true).length;
      this.conTractWithoutCertificate = validData.filter((item) => item.isSignDigitalCertificate === false).length;

      const notifyWarningStr = this.commonService.format(this.message.getMessage('messages.warning_multi_approve_lot'), dataSource.length - validData.length, dataSource.length, validData.length);
      this.notifyWarning = validData.length === dataSource.length ? '' : notifyWarningStr;
      this.dataSource = validData;

    }
  }

  /**
   * View document detail.
   * @param id The document id.
   */
  viewDetail(id) {
    this.router.navigate(['/home-enterprise/view-document/' + id]);
  }

  /**
   * Click on cancel button.
   */
  onClickCancelButton() {
    this.actions.next(ApproveDocumentListComponent.CLOSE_ACTION);
  }

  /**
   * Click on confirm button.
   */
  onClickConfirmButton() {
    if (this.dataSource.some((item: any) => item.isSignDigitalCertificate === true)) {
      this.actions.next(ApproveDocumentListComponent.CONFIRM_ACTION);
    } else {
      // this.dialog.open(ApprovalDocumentComponent, {
      //   width: '40%',
      //   data: {
      //     document: this.dataSource
      //   }
      // });
      this.actions.next(ApproveDocumentListComponent.CONFIRM_ACTION_NON_CERTIFICATE);
    }

  }
  
  /**
   * Load document by sign all.
   */
  private loadDocumentsByApproveAll() {

    this.documentService.getDocumentsByApproveAll(this.filterSignAll)
      .subscribe(rs => {
        if (rs && rs.data) {
          this.dataSource = rs.data;
          this.dataSource.sort((a, b) => {
            if (a.isSignDigitalCertificate === true && b.isSignDigitalCertificate === false) {
              return -1;
            } else if (a.isSignDigitalCertificate === false && b.isSignDigitalCertificate === true) {
              return 1; // b đứng trước a
            } else {
              return 0;
            }
          });
          this.noOfFiles = this.dataSource.filter(item => item.isSignDigitalCertificate === true).reduce(function(s, a) {
            return s + a.contractAttachments.length;
          }, 0);
        }
        if (!this.dataSource.some(item => item.isSignDigitalCertificate === true)) {
          this.typeContracts = ApproveDocumentListComponent.CONFIRM_ACTION_NON_CERTIFICATE;
        } else if (!this.dataSource.some(item => item.isSignDigitalCertificate === false)) {
          this.typeContracts = ApproveDocumentListComponent.TYPE_CONTRACT_WITH_CERTIFICATE;
        } else {
          this.typeContracts = ApproveDocumentListComponent.TYPE_CONTRACT_MIX_CERTIFICATE;
        }
        this.conTractWithCertificate = this.dataSource.filter((item) => item.isSignDigitalCertificate === true).length;
        this.conTractWithoutCertificate = this.dataSource.filter((item) => item.isSignDigitalCertificate === false).length;
      });
  }

  async actionConfirmSign() {
    let listApproverSignMoha = [];
    if (this.signOption === ApproveDocumentListComponent.SIGN_ALL) {
      listApproverSignMoha = this.dataSource.filter(doc => doc.isEmploymentContract && doc.isSignDigitalCertificate);
    } else {
      listApproverSignMoha = this.dataSource.filter(doc => doc.status == 2 && doc.isEmploymentContract && doc.isSignDigitalCertificate);
    }
    if (listApproverSignMoha.length > 0) {
      if (this.userType == 1 || this.userType == 2) {
        this.checkAuthenVneid(() => this.actionSignAll());
        return
      }
      this.actionSignAll();
    }
    this.onClickConfirmButton();
  }


  actionSignAll() {
    this.checkTindy(() => {
      this.onClickConfirmButton();
    });
  }

  checkTindy(callback: () => void){
    this.contractService.checkTindyUser().subscribe(ref => {
      if(!ref.success){
        this.toastr.error(ref.message);
        return;
      }
      if(ref.data == 0 || ref.data == 2 ){
         //Popup anthention data
          let message = "";
         if(ref.data == 2){
         message = this.message.getMessage('notifyTindy.notify');
         }else if(ref.data == 0){
         message = this.message.getMessage('notifyTindy.notify_2')
         }
        const confirmDialog = this.dialog.open(WarningDataAuthenticationComponent, {
        width: '469px',
        height: '348px',
        data: {
          message
        }
         });
         confirmDialog.afterClosed().subscribe(ref => {
          if (ref) {
            this.dialog.open(SignAuthenticationPopupComponent, {
            panelClass: 'sign-authentication',
            width: '791px',
            height: 'auto',
            data: {
              message
            }
          });
          }
       });
      }else if(ref.data == 1){
        callback();
      }
    })
  }

  checkAuthenVneid(callback?: () => void) {
    this.documentMohaService.getCheckVneidConfirm(null, true).subscribe(res => {
      if (res.success) {
        this.dataCheckVneid = res.data;
        switch (this.dataCheckVneid.typeVerify) {
          case 'SHARE_INFO': 
            this.openRequestConfirmIdentity(callback);
            break;
          case 'FACE_MATCH': 
            this.openRequestConfirmIdentity(callback);
            break;
          case 'VERIFIED': 
            callback();
            break;
        }
      } else {
        this.toastr.error(res.message);
      }
    })
  }

  private openRequestConfirmIdentity(callback?: () => void): void {
    const dialogRef = this.dialog.open(RequestConfirmIdentityComponent, {
      width: this.deviceService.isMobile() ? '100%' : '640px',
      panelClass: 'scontract-overlay-dialog',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.openEnterIdentityVneid(callback);
      }
    });
  }

  private openEnterIdentityVneid(callback?: () => void): void {
    const dialogRef = this.dialog.open(EnterIdentityVneidComponent, {
      panelClass: 'sign-authentication',
      width: '1080px',
      maxWidth: '90vw',
      height: 'auto',
      disableClose: true,
      data: {
        documentId: null,
        dataCheckVneid: this.dataCheckVneid,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result) {
        this.openRequestConfirmIdentity(callback);
        return;
      } else {
        callback();
      }
    });
  }
}
